import { Component, Input } from '@angular/core';
import { ColoredChip } from '../../types/common';
import { ColoredChipComponent } from '../colored-chip/colored-chip.component';
import { NgFor } from '@angular/common';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-colored-chip-list',
  imports: [ColoredChipComponent, NgFor],
  templateUrl: './colored-chip-list.component.html',
  styleUrl: './colored-chip-list.component.scss'
})
export class ColoredChipListComponent implements ICellRendererAngularComp{
  @Input()chips: ColoredChip[] =[];
  agInit(params: ICellRendererParams): void {
    this.chips = params.value || [];
  }

  refresh(): boolean {
    return false;
  }
}
